import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_up",
  "use": "icon-ic_up-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 5\" id=\"icon-ic_up\">\n  <path fill-rule=\"evenodd\" d=\"M0.758,5.000 L5.000,0.757 L9.243,5.000 L0.758,5.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/ic_up.svg
// module id = gSxi
// module chunks = 12